import '../stylesheets/App.css';
import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

// Extrae texto plano del nodo HAST de react-markdown
function getNodeText(node) {
    if (!node) return '';
    if (node.type === 'text') return node.value;
    if (node.children) return node.children.map(getNodeText).join('');
    return '';
}

// Genera el mismo slug que usa el índice del markdown:
// - minúsculas
// - elimina todo excepto letras (con tildes), dígitos, espacios y guiones
// - espacios → guiones (sin colapsar dobles, para que "A — B" → "a--b")
function slugify(str) {
    return str
        .toLowerCase()
        .replace(/[^a-z0-9áéíóúüàèìòùñ\s-]/g, '')
        .replace(/\s+/g, '-');
}

const makeHeading = (Tag, style, className) => ({ node, children, ...props }) => {
    const id = slugify(getNodeText(node));
    return (
        <Tag
            id={id}
            className={className}
            style={{ scrollMarginTop: '80px', ...style }}
            {...props}
        >
            {children}
        </Tag>
    );
};

const mdComponents = {
    table: ({ node, ...props }) => (
        <div className="table-responsive">
            <table className="table table-sm table-bordered table-hover" {...props} />
        </div>
    ),
    thead: ({ node, ...props }) => <thead className="table-dark" {...props} />,
    code: ({ node, inline, ...props }) =>
        inline
            ? <code style={{ background: '#f0f0f0', padding: '2px 5px', borderRadius: 3, fontSize: '0.9em' }} {...props} />
            : <pre style={{ background: '#f5f5f5', padding: '1rem', borderRadius: 4, overflowX: 'auto', fontSize: '0.85em' }}><code {...props} /></pre>,
    h1: makeHeading('h1', {}, 'general-subtitle text-center my-4'),
    h2: makeHeading('h2', { borderBottom: '2px solid #1a3c5e', paddingBottom: '0.4rem', marginTop: '2rem', color: '#1a3c5e' }),
    h3: makeHeading('h3', { color: '#2c5f8a', marginTop: '1.5rem' }),
    h4: makeHeading('h4', { color: '#3a7ab8', marginTop: '1.2rem' }),
    blockquote: ({ node, ...props }) => (
        <blockquote style={{ borderLeft: '4px solid #1a3c5e', paddingLeft: '1rem', color: '#555', margin: '1rem 0', background: '#f8f9fa', paddingTop: '0.5rem', paddingBottom: '0.5rem', borderRadius: '0 4px 4px 0' }} {...props} />
    ),
    hr: () => <hr style={{ borderColor: '#ccc', margin: '2rem 0' }} />,
};

function Documentacion() {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        fetch('/DOCUMENTACION.md')
            .then(res => {
                if (!res.ok) throw new Error('No se pudo cargar la documentación');
                return res.text();
            })
            .then(text => {
                setContent(text);
                setLoading(false);
            })
            .catch(() => {
                setError(true);
                setLoading(false);
            });
    }, []);

    if (loading) return <div className="container my-5 text-center">Cargando documentación...</div>;
    if (error) return <div className="container my-5 text-center text-danger">Error al cargar la documentación.</div>;

    return (
        <div className="container my-5" style={{ maxWidth: 900 }}>
            <ReactMarkdown components={mdComponents}>
                {content}
            </ReactMarkdown>
        </div>
    );
}

export default Documentacion;
